import React__default, { useContext } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { O as OnCloseContext, T as TypeContext } from './Context-CQp00lUw.js';
import { I as Icon } from '../Icon/Icon-CpzUnHit.js';
import { t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { T as Text } from '../Text/Text-nnmbpLTK.js';
import { T as TextButton } from '../Button/TextButton/TextButton-DBMcje7x.js';

const SheetHeaderCloseButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30060407__sc-1g86e4g-0"
})(["padding:", ";color:", ";&:hover{color:", ";}"], ({
  theme
}) => theme.spacing.base, ({
  theme,
  reverse
}) => reverse ? theme.palette.white : theme.typography.color.tertiary, ({
  theme,
  reverse
}) => reverse ? theme.palette.gray[150] : theme.typography.color.primary);
const Header = /*#__PURE__*/styled.header.withConfig({
  componentId: "sc-storm-ui-30060407__sc-1g86e4g-1"
})(["position:sticky;top:0;max-width:100%;flex-wrap:wrap;display:flex;flex-direction:", ";align-items:center;padding:", ";gap:", ";background-color:", ";", ""], ({
  reverse
}) => reverse ? 'row-reverse' : 'row', ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.surface.backgroundColor, ({
  withBoxShadow
}) => withBoxShadow && css(["box-shadow:0px 1px 4px rgba(36,47,63,0.15),0px 0px 2px rgba(35,47,63,0.2);"]));
const HeaderContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30060407__sc-1g86e4g-2"
})(["display:flex;flex:1;flex-direction:row;flex-wrap:wrap;align-items:center;gap:", ";max-width:100%;"], ({
  theme
}) => theme.spacing.large);
const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30060407__sc-1g86e4g-3"
})(["flex:1;"]);
function SheetHeader({
  closeButton,
  closeButtonLabel,
  actions,
  children
}) {
  const onClose = useContext(OnCloseContext);
  const type = useContext(TypeContext);
  const isLightType = type === 'light';
  return /*#__PURE__*/React__default.createElement(Header, {
    reverse: closeButton === 'end',
    withBoxShadow: isLightType
  }, closeButton !== 'false' && /*#__PURE__*/React__default.createElement(SheetHeaderCloseButton, {
    onClick: onClose,
    reverse: !isLightType
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: times,
    size: "lg",
    "aria-hidden": "true",
    blockSize: false
  }), /*#__PURE__*/React__default.createElement(Text, {
    type: "sr-only"
  }, closeButtonLabel)), /*#__PURE__*/React__default.createElement(HeaderContainer, null, /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, children), actions && /*#__PURE__*/React__default.createElement("div", null, actions)));
}
SheetHeader.propTypes = {
  closeButton: PT.oneOf(['start', 'end', 'false']),
  closeButtonLabel: PT.string,
  actions: PT.node,
  children: PT.node
};
SheetHeader.defaultProps = {
  closeButton: 'start',
  closeButtonLabel: 'Close sheet',
  actions: undefined,
  children: undefined
};

export { SheetHeader as S };
//# sourceMappingURL=SheetHeader-BQ5MnhpP.js.map
